import React from "react";
import styles from "./BlogSetupWizard.module.css";

function StepMenuItem({ active, text }) {
  return (
    <li className={`${styles["nav-item"]} ${active && styles.active}`}>
      {text}
    </li>
  );
}

StepMenuItem.defaultProps = {
  active: false,
};

export default StepMenuItem;
